export const AUTH_HEADER = process.env['NEXT_PUBLIC_AUTH_HEADER'] ?? 'Authorization';
export const AUTH_TOKEN_PREFIX = process.env['NEXT_PUBLIC_AUTH_TOKEN_PREFIX'] ?? 'Bearer';
export const LANGUAGE_HEADER = 'Accept-Language';
export const APP_VERSION_HEADER = 'X-App-Version';
export const APP_PARTNER_ID_HEADER = 'X-SIGNALLER-INFO';

export const API_URL = process.env['NEXT_PUBLIC_API_URL'] ?? '';

export const QUERY_CACHE = {
  staleTime: 300000, // 5 mins
  cacheTime: 600000, // 10 mins,
} as const;

export const JSON_HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
} as const;
